module.exports = __webpack_public_path__ + "img/commitment-file-icon.a424c057.svg";